import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABELS } from "@/lib/api";
import { SignedImage } from "@/lib/signedFile";
import Logo from "@/components/Logo";
import {
  LayoutDashboard,
  BookOpen,
  ClipboardList,
  Users,
  GraduationCap,
  Building2,
  UserCog,
  Bell,
  LogOut,
  Menu,
  X,
  Home,
  FileCheck,
  FileText,
  HandCoins,
  Compass,
  Library,
  BookOpenCheck,
  Video,
  Award,
  MessageSquare,
  User,
  Briefcase,
  School,
  Handshake,
  UserCheck,
  Settings2,
  FileSignature,
  FileSpreadsheet,
  LifeBuoy,
  ClipboardCheck,
  Sparkles,
  Route,
  AlertTriangle,
  Activity,
  BarChart3,
  Ban,
  ShieldCheck,
} from "lucide-react";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import ThemeToggle from "@/components/ThemeToggle";
import NotificationsInbox from "@/components/NotificationsInbox";
import GlobalSearch from "@/components/GlobalSearch";
import InterventionShortcut from "@/components/InterventionShortcut";
import MobileMoreSheet from "@/components/MobileMoreSheet";
import { MoreHorizontal } from "lucide-react";

const NAV_BY_ROLE = {
  super_admin: [
    { to: "/dashboard", label: "الرئيسية", short: "الرئيسية", icon: LayoutDashboard, testId: "nav-home" },
    { to: "/dashboard/users", label: "المستخدمون", short: "المستخدمون", icon: Users, testId: "nav-users" },
    { to: "/dashboard/students-overview", label: "لوحة أداء الطلاب", short: "أداء الطلاب", icon: BarChart3, testId: "nav-students-overview" },
    { to: "/dashboard/association-timeline", label: "لوحة التايم لاين", short: "التايم لاين", icon: Activity, testId: "nav-association-timeline" },
    { to: "/dashboard/interventions", label: "تدخّل عاجل", short: "التدخلات", icon: ClipboardCheck, testId: "nav-interventions" },
    { to: "/dashboard/opportunities-queue", label: "إدارة الفرص التدريبية", short: "الفرص", icon: ClipboardCheck, testId: "nav-opps-queue" },
    { to: "/dashboard/applications", label: "إدارة تسكين الطلاب", short: "التسكين", icon: ClipboardList, testId: "nav-applications" },
    { to: "/dashboard/placement-cancellations", label: "طلبات إلغاء التسكين", short: "طلبات الإلغاء", icon: Ban, testId: "nav-placement-cancellations" },
    { to: "/dashboard/placement-settings", label: "إعدادات التسكين", icon: Settings2, testId: "nav-placement-settings" },
    { to: "/dashboard/surveys", label: "استبيانات الطلاب", icon: FileSpreadsheet, testId: "nav-surveys" },
    { to: "/dashboard/association-surveys", label: "استبيانات الجمعيات", icon: Handshake, testId: "nav-assoc-surveys" },
    { to: "/dashboard/institutional-assessment", label: "التقييم المؤسسي", icon: ShieldCheck, testId: "nav-institutional-assessment" },
    { to: "/dashboard/opportunities", label: "فرص التدريب التعاوني", icon: BookOpen, testId: "nav-opportunities" },
    { to: "/dashboard/weekly-pulse", label: "التقييم الأسبوعي", icon: Activity, testId: "nav-weekly-pulse" },
    { to: "/dashboard/performance-indicators", label: "التقييم الشهري", icon: BarChart3, testId: "nav-performance-indicators" },
    { to: "/dashboard/landing", label: "الصفحة الرئيسية", icon: Sparkles, testId: "nav-landing-admin" },
    { to: "/dashboard/ambassadors", label: "برنامج السفراء", icon: Award, testId: "nav-ambassadors-admin" },
    { to: "/dashboard/support-admin", label: "تذاكر الدعم", icon: LifeBuoy, testId: "nav-support-admin" },
    { to: "/dashboard/courses", label: "المقررات", icon: Library, testId: "nav-courses" },
    { to: "/dashboard/certificates-admin", label: "الشهادات", icon: Award, testId: "nav-certificates-admin" },
    { to: "/dashboard/admin/contracts", label: "العقود", icon: FileSignature, testId: "nav-admin-contracts" },
    { section: "الجانب التقني" },
    { to: "/dashboard/contact-requests", label: "طلبات التواصل", icon: Handshake, testId: "nav-contact-requests" },
    { to: "/dashboard/recruiter-nominations", label: "ترشيحات جهات الاستقطاب", icon: Briefcase, testId: "nav-recruiter-nominations" },
    { to: "/dashboard/complaints-admin", label: "شكاوى الطلاب", icon: LifeBuoy, testId: "nav-complaints-admin" },
    { to: "/dashboard/admin/funding/requests", label: "طلبات التمويل", icon: HandCoins, testId: "nav-admin-funding" },
    { to: "/dashboard/admin/exceptions", label: "استثناءات الإدارة", icon: AlertTriangle, testId: "nav-admin-exceptions" },
    { to: "/dashboard/integrations", label: "التكاملات والبريد", icon: Settings2, testId: "nav-integrations" },
    { to: "/dashboard/sessions-admin", label: "الجلسات (النظرة التشغيلية)", icon: Video, testId: "nav-sessions-admin" },
  ],
  student: [
    { to: "/dashboard", label: "لوحتي", short: "الرئيسية", icon: LayoutDashboard, testId: "nav-home" },
    { to: "/dashboard/journey", label: "رحلتي التدريبية", short: "رحلتي", icon: Route, testId: "nav-journey" },
    { to: "/opportunities", label: "استكشاف الفرص", short: "الفرص", icon: Compass, testId: "nav-explore" },
    { to: "/dashboard/applications", label: "طلباتي", short: "طلباتي", icon: FileCheck, testId: "nav-applications" },
    { to: "/dashboard/my-courses", label: "برنامج الإعداد والتهيئة", short: "الإعداد", icon: BookOpenCheck, testId: "nav-my-courses" },
    { to: "/dashboard/tasks", label: "مهامي", short: "المهام", icon: ClipboardList, testId: "nav-tasks" },
    { to: "/dashboard/my-enrichment", label: "الأنشطة الإثرائية", short: "الإثراء", icon: Sparkles, testId: "nav-student-enrichment" },
    { to: "/dashboard/my-ambassador", label: "سفير عماد", short: "سفير عماد", icon: Award, testId: "nav-student-ambassador" },
    { to: "/dashboard/sessions", label: "جلساتي", short: "الجلسات", icon: Video, testId: "nav-sessions" },
    { to: "/dashboard/chat", label: "الدردشة مع الموجّه", short: "الدردشة", icon: MessageSquare, testId: "nav-chat" },
    { to: "/dashboard/certificates", label: "شهاداتي", icon: Award, testId: "nav-certificates" },
    { to: "/dashboard/reports", label: "تقاريري الأسبوعية", icon: FileSpreadsheet, testId: "nav-reports" },
    { to: "/dashboard/contracts", label: "العقود والتعهدات", icon: FileSignature, testId: "nav-contracts" },
    { to: "/dashboard/notifications", label: "التنبيهات", icon: Bell, testId: "nav-notifications" },
    { to: "/dashboard/supervision-requests", label: "المشرف الأكاديمي", icon: UserCheck, testId: "nav-supervision" },
    { to: "/dashboard/profile", label: "الملف الشخصي", icon: User, testId: "nav-profile" },
  ],
  association: [
    { to: "/dashboard", label: "الرئيسية", short: "الرئيسية", icon: Building2, testId: "nav-home" },
    { to: "/dashboard/linked-opportunities", label: "الفرص المرتبطة", short: "الفرص", icon: BookOpen, testId: "nav-linked-opps" },
    { to: "/dashboard/students-directory?filter=placed", label: "الطلاب الذين تم تسكينهم", short: "الطلاب", icon: Users, testId: "nav-students-placed", matchQuery: "filter=placed" },
    { to: "/dashboard/tasks", label: "المهام والتقييم", short: "المهام", icon: ClipboardList, testId: "nav-tasks" },
    { to: "/dashboard/sessions", label: "الجلسات الثلاثية", short: "الجلسات", icon: Video, testId: "nav-sessions" },
    { to: "/dashboard/contracts", label: "العقود", short: "العقود", icon: FileSignature, testId: "nav-contracts" },
    { to: "/dashboard/institutional-assessment", label: "التقييم المؤسسي", short: "التقييم", icon: ShieldCheck, testId: "nav-institutional-assessment" },
    { to: "/dashboard/certificates", label: "شهادات الجمعية", short: "الشهادات", icon: Award, testId: "nav-certificates" },
  ],
  mentor: [
    { to: "/dashboard", label: "الرئيسية", short: "الرئيسية", icon: GraduationCap, testId: "nav-home" },
    { to: "/dashboard/my-students", label: "أداء طلابي", short: "أداء طلابي", icon: Users, testId: "nav-my-students" },
    { to: "/dashboard/applications", label: "الطلاب", short: "الطلاب", icon: UserCheck, testId: "nav-students" },
    { to: "/dashboard/sessions", label: "الجلسات", short: "الجلسات", icon: Video, testId: "nav-sessions" },
    { to: "/dashboard/chat", label: "الدردشة مع الطلاب", short: "الدردشة", icon: MessageSquare, testId: "nav-chat" },
  ],
  recreation_mentor: [
    { to: "/dashboard/enrichment", label: "مساحة الإثراء", short: "الإثراء", icon: Sparkles, testId: "nav-enrichment" },
  ],
  content_creator: [
    { to: "/dashboard", label: "الرئيسية", icon: UserCog, testId: "nav-home" },
    { to: "/dashboard/courses", label: "مقرراتي", icon: Library, testId: "nav-courses" },
  ],
  donor: [
    { to: "/dashboard", label: "لوحة الأثر", short: "الأثر", icon: HandCoins, testId: "nav-home" },
    { to: "/dashboard/funding/requests", label: "طلبات التمويل", short: "التمويل", icon: FileText, testId: "nav-funding-requests" },
    { to: "/dashboard/performance-indicators", label: "التقييمات الشهرية والمؤشرات", short: "التقييمات", icon: BarChart3, testId: "nav-donor-monthly" },
  ],
  recruiter: [
    { to: "/dashboard", label: "الخريجون المؤهلون", icon: Briefcase, testId: "nav-home" },
    { to: "/dashboard/contact-requests", label: "طلبات التواصل", icon: Handshake, testId: "nav-contact-requests" },
  ],
  faculty: [
    { to: "/dashboard", label: "طلابي (التدريب التعاوني)", icon: School, testId: "nav-home" },
    { to: "/dashboard/supervision-requests", label: "طلبات الإشراف", icon: UserCheck, testId: "nav-supervision" },
  ],
};

export default function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [desktop, setDesktop] = useState(() => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches);
  useEffect(() => { const media=window.matchMedia("(min-width: 1024px)"); const sync=()=>setDesktop(media.matches); sync(); media.addEventListener("change",sync); return()=>media.removeEventListener("change",sync); }, []);

  // IOS-02 fix: lock body scroll when mobile drawer is open, preserve scroll position.
  // Uses the negative-top technique so the drawer always renders at the visual-viewport
  // top on iOS Safari, and scrollY is restored to within ±1px on close.
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (open) {
      const y = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.emadLockedY = String(y);
      document.body.style.position = "fixed";
      document.body.style.top = `-${y}px`;
      document.body.style.insetInlineStart = "0";
      document.body.style.insetInlineEnd = "0";
      document.body.style.width = "100%";
    } else if (document.body.dataset.emadLockedY !== undefined) {
      const y = parseInt(document.body.dataset.emadLockedY || "0", 10) || 0;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.insetInlineStart = "";
      document.body.style.insetInlineEnd = "";
      document.body.style.width = "";
      delete document.body.dataset.emadLockedY;
      window.scrollTo(0, y);
    }
    return () => {
      // Safety cleanup if the layout unmounts while open
      if (open) {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.insetInlineStart = "";
        document.body.style.insetInlineEnd = "";
        document.body.style.width = "";
      }
    };
  }, [open]);

  // Close drawer, announce the new view, and move keyboard focus to its content.
  useEffect(() => {
    setOpen(false);
    setMoreOpen(false);
    requestAnimationFrame(() => document.getElementById("main-content")?.focus({ preventScroll: true }));
  }, [location.pathname, location.search]);

  if (!user) return null;
  const roleItems = NAV_BY_ROLE[user.role] || [];
  const operationalRoles = ["super_admin", "student", "association", "mentor", "faculty"];
  const withInterventions = user.role === "super_admin"
    ? roleItems
    : operationalRoles.includes(user.role)
      ? [...roleItems, { to: "/dashboard/weekly-pulse", label: "التقييم الأسبوعي", icon: Activity, testId: "nav-weekly-pulse" }, { to: "/dashboard/performance-indicators", label: "التقييم الشهري", icon: BarChart3, testId: "nav-performance-indicators" }, { to: "/dashboard/interventions", label: "تدخّل عاجل", icon: ClipboardCheck, testId: "nav-interventions" }]
      : roleItems;
  const rawItems = user.role === "super_admin" ? withInterventions : [...withInterventions, { to: "/dashboard/support", label: "فتح تذكرة دعم", icon: LifeBuoy, testId: "nav-support" }];
  // Hide academic supervision nav from graduates
  const items = user.role === "student" && user.is_graduate
    ? rawItems.filter((it) => it.to !== "/dashboard/supervision-requests")
    : rawItems;

  const handleLogout = async () => {
    await logout();
    toast.success("تم تسجيل الخروج");
    navigate("/");
  };

  return (
    <div className="min-h-screen-safe bg-slate-50 flex w-full max-w-full overflow-x-hidden" data-testid="dashboard-layout">
      <a href="#main-content" className="skip-link">تجاوز إلى المحتوى الرئيسي</a>
      {/* Sidebar */}
      <aside
        className={`fixed lg:sticky top-0 h-screen-safe w-64 max-w-[85vw] bg-cream-50 border-s border-cream-200 flex flex-col z-40 transition-transform duration-300 will-change-transform overscroll-contain
        ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
        data-testid="sidebar"
        id="dashboard-sidebar"
        aria-hidden={!desktop && !open ? "true" : undefined}
        inert={!desktop && !open ? true : undefined}
        style={{
          insetInlineEnd: 0,
          paddingTop: "env(safe-area-inset-top)",
          paddingBottom: "env(safe-area-inset-bottom)",
          WebkitTransform: open ? "translate3d(0,0,0)" : undefined,
        }}
      >
        <div className="p-3 border-b border-cream-200 flex items-center justify-between">
          <Link to="/" className="block">
            <Logo variant="navy" size={52} />
          </Link>
          <button
            onClick={() => setOpen(false)}
            className="lg:hidden inline-flex items-center justify-center min-h-[44px] min-w-[44px] rounded-lg text-slate-600 hover:bg-white/60"
            aria-label="إغلاق القائمة"
            data-testid="sidebar-close-btn"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-3 border-b border-cream-200">
          {user.role === "association" ? (
            <Link
              to="/dashboard/association-profile"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 rounded-xl p-2 -m-2 hover:bg-white/80 transition-colors group"
              data-testid="assoc-info-card"
              title="فتح الملف التعريفي للجمعية"
            >
              <div className="h-9 w-9 rounded-full bg-gradient-to-br from-teal-700 to-teal-900 grid place-items-center text-white font-bold overflow-hidden shrink-0">
                {user.avatar_url ? (
                  <SignedImage
                    fileId={user.avatar_url}
                    alt=""
                    className="h-full w-full object-cover"
                    fallback={<span>{user.name?.[0] || "?"}</span>}
                  />
                ) : (
                  <span>{user.name?.[0] || "?"}</span>
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-slate-900 truncate group-hover:text-teal-800">
                  {user.organization_name || user.name}
                </div>
                <div className="text-[10px] text-teal-700 font-medium truncate">
                  {ROLE_LABELS[user.role]} · <span className="underline decoration-dotted">تعديل الملف</span>
                </div>
              </div>
            </Link>
          ) : (
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-full bg-gradient-to-br from-teal-700 to-teal-900 grid place-items-center text-white font-bold overflow-hidden">
                {user.avatar_url ? (
                  <SignedImage
                    fileId={user.avatar_url}
                    alt=""
                    className="h-full w-full object-cover"
                    fallback={<span>{user.name?.[0] || "?"}</span>}
                  />
                ) : (
                  <span>{user.name?.[0] || "?"}</span>
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-slate-900 truncate">{user.name}</div>
                <div className="text-[10px] text-teal-700 font-medium">{ROLE_LABELS[user.role]}</div>
              </div>
            </div>
          )}
        </div>

        <nav className="flex-1 overflow-y-auto p-2 space-y-0.5">
          <div className="px-3 pb-1 pt-1 text-[9px] font-black uppercase tracking-widest text-slate-400">التنقل الرئيسي</div>
          {items.map((item, idx) => {
            // Section divider (e.g. "الجانب التقني" for super_admin)
            if (item.section) {
              return (
                <div
                  key={`section-${idx}`}
                  className="mt-2 pt-2 border-t border-cream-200 px-3 pb-0.5 text-[9px] font-black uppercase tracking-widest text-slate-400"
                  data-testid={`sidebar-section-${idx}`}
                >
                  {item.section}
                </div>
              );
            }
            // Split path/query so we can check both parts for active state
            const [itemPath, itemQuery] = item.to.split("?");
            const isSamePath =
              location.pathname === itemPath ||
              (itemPath !== "/dashboard" && location.pathname.startsWith(itemPath));
            let isActive;
            if (item.matchQuery) {
              // Both path AND query must match for this to be the active nav item
              isActive = isSamePath && location.search.includes(item.matchQuery);
            } else if (itemQuery) {
              isActive = isSamePath && location.search.includes(itemQuery);
            } else {
              // Path-only item: active only when no other sibling with query matches
              const siblingWithQuery = items.some(
                (it) => it !== item && it.to && (it.to.split("?")[0] === itemPath) && it.matchQuery
              );
              isActive = isSamePath && !siblingWithQuery;
            }
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-2 min-h-[32px] px-3 py-1.5 rounded-lg text-[13px] font-medium transition-colors
                ${
                  isActive
                    ? "bg-white text-teal-800 border border-cream-200 card-shadow"
                    : "text-slate-700 hover:bg-white/60 border border-transparent"
                }`}
                data-testid={item.testId}
              >
                <Icon className="h-4 w-4 shrink-0" strokeWidth={1.75} />
                <span className="truncate">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-2 border-t border-cream-200 space-y-0.5">
          <Link
            to="/"
            className="flex items-center gap-2 min-h-[32px] px-3 py-1.5 rounded-lg text-[13px] font-medium text-slate-600 hover:bg-white/60 transition-colors"
            data-testid="nav-back-home"
          >
            <Home className="h-4 w-4" strokeWidth={1.75} />
            <span>العودة للموقع</span>
          </Link>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2 min-h-[32px] px-3 py-1.5 rounded-lg text-[13px] font-medium text-red-600 hover:bg-red-50 transition-colors"
            data-testid="logout-btn"
          >
            <LogOut className="h-4 w-4" strokeWidth={1.75} />
            <span>تسجيل الخروج</span>
          </button>
          {/* Siaq secondary identity — bottom of sidebar (desktop + mobile drawer) */}
          <div
            className="mt-3 pt-3 border-t border-cream-200 flex flex-col items-center gap-1.5 bg-white/60 rounded-lg py-3 px-2"
            data-testid="siaq-badge-sidebar"
          >
            <img
              src={require("@/assets/siaq-logo.png")}
              alt="شركة سياق"
              className="h-10 w-auto object-contain select-none pointer-events-none"
              draggable={false}
            />
            <p className="text-[10px] text-slate-500 font-medium tracking-wide">إحدى منتجات سياق</p>
          </div>
        </div>
      </aside>

      {/* Overlay for mobile */}
      {open && (
        <div
          className="fixed inset-0 bg-slate-900/50 z-30 lg:hidden"
          onClick={() => setOpen(false)}
          data-testid="sidebar-overlay"
          aria-hidden="true"
        />
      )}

      {/* Main */}
      <div className="flex-1 min-w-0 flex flex-col w-full max-w-full">
        <header className="sticky top-0 z-20 h-14 sm:h-16 bg-cream-50/90 backdrop-blur-xl border-b border-cream-200 flex items-center px-3 sm:px-6 lg:px-8 gap-2 sm:gap-3" style={{ paddingTop: "env(safe-area-inset-top)" }}>
          <button
            className="lg:hidden inline-flex items-center justify-center min-h-11 min-w-11 -ms-1 rounded-lg hover:bg-slate-100 active:bg-slate-200"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-btn"
            aria-expanded={open}
            aria-controls="dashboard-sidebar"
            aria-label={open ? "إغلاق القائمة" : "فتح القائمة"}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
          <GlobalSearch />
          <div className="hidden lg:flex items-center gap-3 text-sm text-slate-500">
            <span>مرحباً بعودتك،</span>
            <span className="text-slate-900 font-semibold">{user.name}</span>
          </div>
          <div className="ms-auto flex items-center gap-1 sm:gap-3">
            {operationalRoles.includes(user.role) && <InterventionShortcut />}
            <ThemeToggle />
            <NotificationsInbox />
          </div>
        </header>

        <main id="main-content" tabIndex={-1} className="flex-1 w-full max-w-full pb-24 lg:pb-0 lg:max-w-7xl lg:mx-auto px-4 py-6 sm:px-6 lg:px-10 lg:py-10 focus:outline-none">{children}</main>
      </div>

      {(() => {
        const bottomItems = items.filter((it) => !it.section);
        const primary = bottomItems.slice(0, 4);
        const overflow = bottomItems.slice(4);
        const overflowActive = overflow.some((item) => {
          const itemPath = item.to.split("?")[0];
          return location.pathname === itemPath || (itemPath !== "/dashboard" && location.pathname.startsWith(itemPath));
        });
        return (
          <nav
            className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-5 border-t border-cream-200 bg-cream-50/95 px-1 backdrop-blur-xl lg:hidden shadow-[0_-4px_16px_-6px_rgba(15,23,42,0.08)]"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            aria-label="التنقل السريع"
            data-testid="mobile-bottom-nav"
          >
            {primary.map((item) => {
              const Icon = item.icon;
              const itemPath = item.to.split("?")[0];
              const active = location.pathname === itemPath || (itemPath !== "/dashboard" && location.pathname.startsWith(itemPath));
              return (
                <Link
                  key={`bottom-${item.to}`}
                  to={item.to}
                  className={`flex min-h-16 min-w-0 flex-col items-center justify-center gap-0.5 px-0.5 text-[11px] font-bold transition-colors active:scale-95 ${active ? "text-teal-800" : "text-slate-500 hover:text-teal-700"}`}
                  aria-current={active ? "page" : undefined}
                  data-testid={`bottom-${item.testId}`}
                >
                  <span className={`grid h-8 w-8 place-items-center rounded-full transition-colors ${active ? "bg-teal-100/70" : ""}`}>
                    <Icon className="h-5 w-5 shrink-0" strokeWidth={active ? 2.25 : 1.75} />
                  </span>
                  <span className="w-full truncate text-center leading-tight">{item.short || item.label}</span>
                </Link>
              );
            })}
            {overflow.length > 0 && (
              <button
                type="button"
                onClick={() => setMoreOpen(true)}
                className={`flex min-h-16 min-w-0 flex-col items-center justify-center gap-0.5 px-0.5 text-[11px] font-bold transition-colors active:scale-95 ${moreOpen || overflowActive ? "text-teal-800" : "text-slate-500 hover:text-teal-700"}`}
                data-testid="bottom-nav-more"
                aria-expanded={moreOpen}
              >
                <span className={`grid h-8 w-8 place-items-center rounded-full transition-colors ${moreOpen || overflowActive ? "bg-teal-100/70" : ""}`}>
                  <MoreHorizontal className="h-5 w-5" strokeWidth={2} />
                </span>
                <span className="leading-tight">المزيد</span>
              </button>
            )}
          </nav>
        );
      })()}

      <MobileMoreSheet
        open={moreOpen}
        onClose={() => setMoreOpen(false)}
        items={items.filter((it) => !it.section).slice(4)}
      />
    </div>
  );
}
